const w_area = [
  {
    country: "Afghanistan",
    zh_cn: "阿富汗",
    sign: "AF",
    c_code: "+93"
  },
  {
    country: "Albania",
    zh_cn: "阿尔巴尼亚",
    sign: "AL",
    c_code: "+355"
  },
  {
    country: "Algeria",
    zh_cn: "阿尔及利亚",
    sign: "DZ",
    c_code: "+213"
  },
  {
    country: "American Samoa",
    zh_cn: "美属萨摩亚",
    sign: "AS",
    c_code: "+1684"
  },
  {
    country: "Andorra",
    zh_cn: "安道尔",
    sign: "AD",
    c_code: "+376"
  },
  {
    country: "Angola",
    zh_cn: "安哥拉",
    sign: "AO",
    c_code: "+244"
  },
  {
    country: "Anguilla",
    zh_cn: "安圭拉",
    sign: "AI",
    c_code: "+1264"
  },
  {
    country: "Antigua and Barbuda",
    zh_cn: "安提瓜和巴布达",
    sign: "AG",
    c_code: "+1268"
  },
  {
    country: "Argentina",
    zh_cn: "阿根廷",
    sign: "AR",
    c_code: "+54"
  },
  {
    country: "Armenia",
    zh_cn: "亚美尼亚",
    sign: "AM",
    c_code: "+374"
  },
  {
    country: "Aruba",
    zh_cn: "阿鲁巴",
    sign: "AW",
    c_code: "+297"
  },
  {
    country: "Australia",
    zh_cn: "澳大利亚",
    sign: "AU",
    c_code: "+61"
  },
  {
    country: "Austria",
    zh_cn: "奥地利",
    sign: "AT",
    c_code: "+43"
  },
  {
    country: "Azerbaijan",
    zh_cn: "阿塞拜疆",
    sign: "AZ",
    c_code: "+994"
  },
  {
    country: "Bahamas",
    zh_cn: "巴哈马",
    sign: "BS",
    c_code: "+1242"
  },
  {
    country: "Bahrain",
    zh_cn: "巴林",
    sign: "BH",
    c_code: "+973"
  },
  {
    country: "Bangladesh",
    zh_cn: "孟加拉国",
    sign: "BD",
    c_code: "+880"
  },
  {
    country: "Barbados",
    zh_cn: "巴巴多斯",
    sign: "BB",
    c_code: "+1246"
  },
  {
    country: "Belarus",
    zh_cn: "白俄罗斯",
    sign: "BY",
    c_code: "+375"
  },
  {
    country: "Belgium",
    zh_cn: "比利时",
    sign: "BE",
    c_code: "+32"
  },
  {
    country: "Belize",
    zh_cn: "伯利兹",
    sign: "BZ",
    c_code: "+501"
  },
  {
    country: "Benin",
    zh_cn: "贝宁",
    sign: "BJ",
    c_code: "+229"
  },
  {
    country: "Bermuda",
    zh_cn: "百慕大群岛",
    sign: "BM",
    c_code: "+1441"
  },
  {
    country: "Bhutan",
    zh_cn: "不丹",
    sign: "BT",
    c_code: "+975"
  },
  {
    country: "Bolivia",
    zh_cn: "玻利维亚",
    sign: "BO",
    c_code: "+591"
  },
  {
    country: "Bosnia and Herzegovina",
    zh_cn: "波斯尼亚和黑塞哥维那",
    sign: "BA",
    c_code: "+387"
  },
  {
    country: "Botswana",
    zh_cn: "博茨瓦纳",
    sign: "BW",
    c_code: "+267"
  },
  {
    country: "Brazil",
    zh_cn: "巴西",
    sign: "BR",
    c_code: "+55"
  },
  {
    country: "Brunei",
    zh_cn: "文莱",
    sign: "BN",
    c_code: "+673"
  },
  {
    country: "Bulgaria",
    zh_cn: "保加利亚",
    sign: "BG",
    c_code: "+359"
  },
  {
    country: "Burkina Faso",
    zh_cn: "布基纳法索",
    sign: "BF",
    c_code: "+226"
  },
  {
    country: "Burundi",
    zh_cn: "布隆迪",
    sign: "BI",
    c_code: "+257"
  },
  {
    country: "Cambodia",
    zh_cn: "柬埔寨",
    sign: "KH",
    c_code: "+855"
  },
  {
    country: "Cameroon",
    zh_cn: "喀麦隆",
    sign: "CM",
    c_code: "+237"
  },
  {
    country: "Canada",
    zh_cn: "加拿大",
    sign: "CA",
    c_code: "+1"
  },
  {
    country: "Cape Verde",
    zh_cn: "开普",
    sign: "CV",
    c_code: "+238"
  },
  {
    country: "Cayman Islands",
    zh_cn: "开曼群岛",
    sign: "KY",
    c_code: "+1345"
  },
  {
    country: "Cabo Verde",
    zh_cn: "佛得角",
    sign: "CV",
    c_code: "+238"
  },
  {
    country: "Central African Republic",
    zh_cn: "中非共和国",
    sign: "CF",
    c_code: "+236"
  },
  {
    country: "Chad",
    zh_cn: "乍得",
    sign: "TD",
    c_code: "+235"
  },
  {
    country: "Chile",
    zh_cn: "智利",
    sign: "CL",
    c_code: "+56"
  },
  {
    country: "Colombia",
    zh_cn: "哥伦比亚",
    sign: "CO",
    c_code: "+57"
  },
  {
    country: "Comoros",
    zh_cn: "科摩罗",
    sign: "KM",
    c_code: "+269"
  },
  {
    country: "Cook Islands",
    zh_cn: "库克群岛",
    sign: "CK",
    c_code: "+682"
  },
  {
    country: "Côte d'Ivoire",
    zh_cn: "科特迪瓦",
    sign: "CI",
    c_code: "+225"
  },
  {
    country: "Costa Rica",
    zh_cn: "哥斯达黎加",
    sign: "CR",
    c_code: "+506"
  },
  {
    country: "Croatia",
    zh_cn: "克罗地亚",
    sign: "HR",
    c_code: "+385"
  },
  {
    country: "Cuba",
    zh_cn: "古巴",
    sign: "CU",
    c_code: "+53"
  },
  {
    country: "Curacao",
    zh_cn: "库拉索",
    sign: "CW",
    c_code: "+599"
  },
  {
    country: "Cyprus",
    zh_cn: "塞浦路斯",
    sign: "CY",
    c_code: "+357"
  },
  {
    country: "Czech",
    zh_cn: "捷克",
    sign: "CZ",
    c_code: "+420"
  },
  {
    country: "Denmark",
    zh_cn: "丹麦",
    sign: "DK",
    c_code: "+45"
  },
  {
    country: "Djibouti",
    zh_cn: "吉布提",
    sign: "DJ",
    c_code: "+253"
  },
  {
    country: "Dominica",
    zh_cn: "多米尼加",
    sign: "DM",
    c_code: "+1767"
  },
  {
    country: "Dominican Republic",
    zh_cn: "多米尼加共和国",
    sign: "DO",
    c_code: "+1809"
  },
  {
    country: "Ecuador",
    zh_cn: "厄瓜多尔",
    sign: "EC",
    c_code: "+593"
  },
  {
    country: "Egypt",
    zh_cn: "埃及",
    sign: "EG",
    c_code: "+20"
  },
  {
    country: "El Salvador",
    zh_cn: "萨尔瓦多",
    sign: "SV",
    c_code: "+503"
  },
  {
    country: "Equatorial Guinea",
    zh_cn: "赤道几内亚",
    sign: "GQ",
    c_code: "+240"
  },
  {
    country: "Eritrea",
    zh_cn: "厄立特里亚",
    sign: "ER",
    c_code: "+291"
  },
  {
    country: "Estonia",
    zh_cn: "爱沙尼亚",
    sign: "EE",
    c_code: "+372"
  },
  {
    country: "Ethiopia",
    zh_cn: "埃塞俄比亚",
    sign: "ET",
    c_code: "+251"
  },
  {
    country: "Faroe Islands",
    zh_cn: "法罗群岛",
    sign: "FO",
    c_code: "+298"
  },
  {
    country: "Fiji",
    zh_cn: "斐济",
    sign: "FJ",
    c_code: "+679"
  },
  {
    country: "Finland",
    zh_cn: "芬兰",
    sign: "FI",
    c_code: "+358"
  },
  {
    country: "France",
    zh_cn: "法国",
    sign: "FR",
    c_code: "+33"
  },
  {
    country: "French Guiana",
    zh_cn: "法属圭亚那",
    sign: "GF",
    c_code: "+594"
  },
  {
    country: "French Polynesia",
    zh_cn: "法属波利尼西亚",
    sign: "PF",
    c_code: "+689"
  },
  {
    country: "Gabon",
    zh_cn: "加蓬",
    sign: "GA",
    c_code: "+241"
  },
  {
    country: "Gambia",
    zh_cn: "冈比亚",
    sign: "GM",
    c_code: "+220"
  },
  {
    country: "Georgia",
    zh_cn: "格鲁吉亚",
    sign: "GE",
    c_code: "+995"
  },
  {
    country: "Germany",
    zh_cn: "德国",
    sign: "DE",
    c_code: "+49"
  },
  {
    country: "Ghana",
    zh_cn: "加纳",
    sign: "GH",
    c_code: "+233"
  },
  {
    country: "Gibraltar",
    zh_cn: "直布罗陀",
    sign: "GI",
    c_code: "+350"
  },
  {
    country: "Greece",
    zh_cn: "希腊",
    sign: "GR",
    c_code: "+30"
  },
  {
    country: "Greenland",
    zh_cn: "格陵兰岛",
    sign: "GL",
    c_code: "+299"
  },
  {
    country: "Grenada",
    zh_cn: "格林纳达",
    sign: "GD",
    c_code: "+1473"
  },
  {
    country: "Guadeloupe",
    zh_cn: "瓜德罗普岛",
    sign: "GP",
    c_code: "+590"
  },
  {
    country: "Guam",
    zh_cn: "关岛",
    sign: "GU",
    c_code: "+1671"
  },
  {
    country: "Guatemala",
    zh_cn: "危地马拉",
    sign: "GT",
    c_code: "+502"
  },
  {
    country: "Guinea",
    zh_cn: "几内亚",
    sign: "GN",
    c_code: "+224"
  },
  {
    country: "Guinea-Bissau",
    zh_cn: "几内亚比绍共和国",
    sign: "GW",
    c_code: "+245"
  },
  {
    country: "Guyana",
    zh_cn: "圭亚那",
    sign: "GY",
    c_code: "+592"
  },
  {
    country: "Haiti",
    zh_cn: "海地",
    sign: "HT",
    c_code: "+509"
  },
  {
    country: "Honduras",
    zh_cn: "洪都拉斯",
    sign: "HN",
    c_code: "+504"
  },
  {
    country: "Hong Kong",
    zh_cn: "中国香港",
    sign: "HK",
    c_code: "+852"
  },
  {
    country: "Hungary",
    zh_cn: "匈牙利",
    sign: "HU",
    c_code: "+36"
  },
  {
    country: "Iceland",
    zh_cn: "冰岛",
    sign: "IS",
    c_code: "+354"
  },
  {
    country: "India",
    zh_cn: "印度",
    sign: "IN",
    c_code: "+91"
  },
  {
    country: "Indonesia",
    zh_cn: "印度尼西亚",
    sign: "ID",
    c_code: "+62"
  },
  {
    country: "Iran",
    zh_cn: "伊朗",
    sign: "IR",
    c_code: "+98"
  },
  {
    country: "Iraq",
    zh_cn: "伊拉克",
    sign: "IQ",
    c_code: "+964"
  },
  {
    country: "Ireland",
    zh_cn: "爱尔兰",
    sign: "IE",
    c_code: "+353"
  },
  {
    country: "Israel",
    zh_cn: "以色列",
    sign: "IL",
    c_code: "+972"
  },
  {
    country: "Italy",
    zh_cn: "意大利",
    sign: "IT",
    c_code: "+39"
  },
  {
    country: "Ivory Coast",
    zh_cn: "象牙海岸",
    sign: "CI",
    c_code: "+225"
  },
  {
    country: "Jamaica",
    zh_cn: "牙买加",
    sign: "JM",
    c_code: "+1876"
  },
  {
    country: "Japan",
    zh_cn: "日本",
    sign: "JP",
    c_code: "+81"
  },
  {
    country: "Jordan",
    zh_cn: "约旦",
    sign: "JO",
    c_code: "+962"
  },
  {
    country: "Kazakhstan",
    zh_cn: "哈萨克斯坦",
    sign: "KZ",
    c_code: "+7"
  },
  {
    country: "Kenya",
    zh_cn: "肯尼亚",
    sign: "KE",
    c_code: "+254"
  },
  {
    country: "Kiribati",
    zh_cn: "基里巴斯",
    sign: "KI",
    c_code: "+686"
  },
  {
    country: "Kuwait",
    zh_cn: "科威特",
    sign: "KW",
    c_code: "+965"
  },
  {
    country: "Kyrgyzstan",
    zh_cn: "吉尔吉斯斯坦",
    sign: "KG",
    c_code: "+996"
  },
  {
    country: "Laos",
    zh_cn: "老挝",
    sign: "LA",
    c_code: "+856"
  },
  {
    country: "Latvia",
    zh_cn: "拉脱维亚",
    sign: "LV",
    c_code: "+371"
  },
  {
    country: "Lebanon",
    zh_cn: "黎巴嫩",
    sign: "LB",
    c_code: "+961"
  },
  {
    country: "Lesotho",
    zh_cn: "莱索托",
    sign: "LS",
    c_code: "+266"
  },
  {
    country: "Liberia",
    zh_cn: "利比里亚",
    sign: "LR",
    c_code: "+231"
  },
  {
    country: "Libya",
    zh_cn: "利比亚",
    sign: "LY",
    c_code: "+218"
  },
  {
    country: "Liechtenstein",
    zh_cn: "列支敦士登",
    sign: "LI",
    c_code: "+423"
  },
  {
    country: "Lithuania",
    zh_cn: "立陶宛",
    sign: "LT",
    c_code: "+370"
  },
  {
    country: "Luxembourg",
    zh_cn: "卢森堡",
    sign: "LU",
    c_code: "+352"
  },
  {
    country: "Macau",
    zh_cn: "中国澳门",
    sign: "MO",
    c_code: "+853"
  },
  {
    country: "Macedonia",
    zh_cn: "马其顿",
    sign: "MK",
    c_code: "+389"
  },
  {
    country: "Madagascar",
    zh_cn: "马达加斯加",
    sign: "MG",
    c_code: "+261"
  },
  {
    country: "Malawi",
    zh_cn: "马拉维",
    sign: "MW",
    c_code: "+265"
  },
  {
    country: "Malaysia",
    zh_cn: "马来西亚",
    sign: "MY",
    c_code: "+60"
  },
  {
    country: "Maldives",
    zh_cn: "马尔代夫",
    sign: "MV",
    c_code: "+960"
  },
  {
    country: "Mali",
    zh_cn: "马里",
    sign: "ML",
    c_code: "+223"
  },
  {
    country: "Malta",
    zh_cn: "马耳他",
    sign: "MT",
    c_code: "+356"
  },
  {
    country: "Martinique",
    zh_cn: "马提尼克",
    sign: "MQ",
    c_code: "+596"
  },
  {
    country: "Mariana lslands",
    zh_cn: "马里亚纳群岛",
    sign: "MI",
    c_code: "+1670"
  },
  {
    country: "Mauritania",
    zh_cn: "毛里塔尼亚",
    sign: "MR",
    c_code: "+222"
  },
  {
    country: "Mauritius",
    zh_cn: "毛里求斯",
    sign: "MU",
    c_code: "+230"
  },
  {
    country: "Mayotte",
    zh_cn: "马约特",
    sign: "YT",
    c_code: "+269"
  },
  {
    country: "Mexico",
    zh_cn: "墨西哥",
    sign: "MX",
    c_code: "+52"
  },
  {
    country: "Moldova",
    zh_cn: "摩尔多瓦",
    sign: "MD",
    c_code: "+373"
  },
  {
    country: "Monaco",
    zh_cn: "摩纳哥",
    sign: "MC",
    c_code: "+377"
  },
  {
    country: "Mongolia",
    zh_cn: "蒙古",
    sign: "MN",
    c_code: "+976"
  },
  {
    country: "Montenegro",
    zh_cn: "黑山",
    sign: "ME",
    c_code: "+382"
  },
  {
    country: "Montserrat",
    zh_cn: "蒙特塞拉特岛",
    sign: "MS",
    c_code: "+1664"
  },
  {
    country: "Morocco",
    zh_cn: "摩洛哥",
    sign: "MA",
    c_code: "+212"
  },
  {
    country: "Mozambique",
    zh_cn: "莫桑比克",
    sign: "MZ",
    c_code: "+258"
  },
  {
    country: "Myanmar",
    zh_cn: "缅甸",
    sign: "MM",
    c_code: "+95"
  },
  {
    country: "Namibia",
    zh_cn: "纳米比亚",
    sign: "NA",
    c_code: "+264"
  },
  {
    country: "Nepal",
    zh_cn: "尼泊尔",
    sign: "NP",
    c_code: "+977"
  },
  {
    country: "Netherlands",
    zh_cn: "荷兰",
    sign: "NL",
    c_code: "+31"
  },
  {
    country: "Netherlands Antilles",
    zh_cn: "荷属安德列斯群岛",
    sign: "AN",
    c_code: "+599"
  },
  {
    country: "New Caledonia",
    zh_cn: "新喀里多尼亚",
    sign: "NC",
    c_code: "+687"
  },
  {
    country: "New Zealand",
    zh_cn: "新西兰",
    sign: "NZ",
    c_code: "+64"
  },
  {
    country: "Nicaragua",
    zh_cn: "尼加拉瓜",
    sign: "NI",
    c_code: "+505"
  },
  {
    country: "Niger",
    zh_cn: "尼日尔",
    sign: "NE",
    c_code: "+227"
  },
  {
    country: "Nigeria",
    zh_cn: "尼日利亚",
    sign: "NG",
    c_code: "+234"
  },
  {
    country: "Norway",
    zh_cn: "挪威",
    sign: "NO",
    c_code: "+47"
  },
  {
    country: "Oman",
    zh_cn: "阿曼",
    sign: "OM",
    c_code: "+968"
  },
  {
    country: "Pakistan",
    zh_cn: "巴基斯坦",
    sign: "PK",
    c_code: "+92"
  },
  {
    country: "Palau",
    zh_cn: "帕劳",
    sign: "PW",
    c_code: "+680"
  },
  {
    country: "Palestine",
    zh_cn: "巴勒斯坦",
    sign: "BL",
    c_code: "+970"
  },
  {
    country: "Panama",
    zh_cn: "巴拿马",
    sign: "PA",
    c_code: "+507"
  },
  {
    country: "Papua New Guinea",
    zh_cn: "巴布亚新几内亚",
    sign: "PG",
    c_code: "+675"
  },
  {
    country: "Paraguay",
    zh_cn: "巴拉圭",
    sign: "PY",
    c_code: "+595"
  },
  {
    country: "Peru",
    zh_cn: "秘鲁",
    sign: "PE",
    c_code: "+51"
  },
  {
    country: "Philippines",
    zh_cn: "菲律宾",
    sign: "PH",
    c_code: "+63"
  },
  {
    country: "Poland",
    zh_cn: "波兰",
    sign: "PL",
    c_code: "+48"
  },
  {
    country: "Portugal",
    zh_cn: "葡萄牙",
    sign: "PT",
    c_code: "+351"
  },
  {
    country: "Puerto Rico",
    zh_cn: "波多黎各",
    sign: "PR",
    c_code: "+1787"
  },
  {
    country: "Qatar",
    zh_cn: "卡塔尔",
    sign: "QA",
    c_code: "+974"
  },
  {
    country: "Republic Of The Congo",
    zh_cn: "刚果共和国",
    sign: "CG",
    c_code: "+242"
  },
  {
    country: "Réunion Island",
    zh_cn: "留尼汪",
    sign: "RE",
    c_code: "+262"
  },
  {
    country: "Romania",
    zh_cn: "罗马尼亚",
    sign: "RO",
    c_code: "+40"
  },
  {
    country: "Russia",
    zh_cn: "俄罗斯",
    sign: "RU",
    c_code: "+7"
  },
  {
    country: "Rwanda",
    zh_cn: "卢旺达",
    sign: "RW",
    c_code: "+250"
  },
  {
    country: "Saint Kitts and Nevis",
    zh_cn: "圣基茨和尼维斯",
    sign: "KN",
    c_code: "+1869"
  },
  {
    country: "Saint Lucia",
    zh_cn: "圣露西亚",
    sign: "LC",
    c_code: "+1758"
  },
  {
    country: "Saint Pierre and Miquelon",
    zh_cn: "圣彼埃尔和密克隆岛",
    sign: "PM",
    c_code: "+508"
  },
  {
    country: "Saint Vincent and The Grenadines",
    zh_cn: "圣文森特和格林纳丁斯",
    sign: "VC",
    c_code: "+1784"
  },
  {
    country: "Saint Kitts and Nevis",
    zh_cn: "圣克里斯托弗和尼维斯",
    sign: "KN",
    c_code: "+1869"
  },
  {
    country: "Samoa",
    zh_cn: "萨摩亚",
    sign: "WS",
    c_code: "+685"
  },
  {
    country: "San Marino",
    zh_cn: "圣马力诺",
    sign: "SM",
    c_code: "+378"
  },
  {
    country: "Sao Tome and Principe",
    zh_cn: "圣多美和普林西比",
    sign: "ST",
    c_code: "+239"
  },
  {
    country: "Saudi Arabia",
    zh_cn: "沙特阿拉伯",
    sign: "SA",
    c_code: "+966"
  },
  {
    country: "Senegal",
    zh_cn: "塞内加尔",
    sign: "SN",
    c_code: "+221"
  },
  {
    country: "Serbia",
    zh_cn: "塞尔维亚",
    sign: "RS",
    c_code: "+381"
  },
  {
    country: "Seychelles",
    zh_cn: "塞舌尔",
    sign: "SC",
    c_code: "+248"
  },
  {
    country: "Sierra Leone",
    zh_cn: "塞拉利昂",
    sign: "SL",
    c_code: "+232"
  },
  {
    country: "Singapore",
    zh_cn: "新加坡",
    sign: "SG",
    c_code: "+65"
  },
  {
    country: "Saint Maarten (Dutch Part)",
    zh_cn: "圣马丁岛（荷兰部分）",
    sign: "SX",
    c_code: "+1721"
  },
  {
    country: "Slovakia",
    zh_cn: "斯洛伐克",
    sign: "SK",
    c_code: "+421"
  },
  {
    country: "Slovenia",
    zh_cn: "斯洛文尼亚",
    sign: "SI",
    c_code: "+386"
  },
  {
    country: "Solomon Islands",
    zh_cn: "所罗门群岛",
    sign: "SB",
    c_code: "+677"
  },
  {
    country: "Somalia",
    zh_cn: "索马里",
    sign: "SO",
    c_code: "+252"
  },
  {
    country: "South Africa",
    zh_cn: "南非",
    sign: "ZA",
    c_code: "+27"
  },
  {
    country: "South Korea",
    zh_cn: "韩国",
    sign: "KR",
    c_code: "+82"
  },
  {
    country: "Spain",
    zh_cn: "西班牙",
    sign: "ES",
    c_code: "+34"
  },
  {
    country: "Sri Lanka",
    zh_cn: "斯里兰卡",
    sign: "LK",
    c_code: "+94"
  },
  {
    country: "Sudan",
    zh_cn: "苏丹",
    sign: "SD",
    c_code: "+249"
  },
  {
    country: "Suriname",
    zh_cn: "苏里南",
    sign: "SR",
    c_code: "+597"
  },
  {
    country: "Swaziland",
    zh_cn: "斯威士兰",
    sign: "SZ",
    c_code: "+268"
  },
  {
    country: "Sweden",
    zh_cn: "瑞典",
    sign: "SE",
    c_code: "+46"
  },
  {
    country: "Switzerland",
    zh_cn: "瑞士",
    sign: "CH",
    c_code: "+41"
  },
  {
    country: "Syria",
    zh_cn: "叙利亚",
    sign: "SY",
    c_code: "+963"
  },
  {
    country: "Taiwan",
    zh_cn: "中国台湾",
    sign: "TW",
    c_code: "+886"
  },
  {
    country: "Tajikistan",
    zh_cn: "塔吉克斯坦",
    sign: "TJ",
    c_code: "+992"
  },
  {
    country: "Tanzania",
    zh_cn: "坦桑尼亚",
    sign: "TZ",
    c_code: "+255"
  },
  {
    country: "Thailand",
    zh_cn: "泰国",
    sign: "TH",
    c_code: "+66"
  },
  {
    country: "Timor-Leste",
    zh_cn: "东帝汶",
    sign: "TL",
    c_code: "+670"
  },
  {
    country: "Togo",
    zh_cn: "多哥",
    sign: "TG",
    c_code: "+228"
  },
  {
    country: "Tonga",
    zh_cn: "汤加",
    sign: "TO",
    c_code: "+676"
  },
  {
    country: "Trinidad and Tobago",
    zh_cn: "特立尼达和多巴哥",
    sign: "TT",
    c_code: "+1868"
  },
  {
    country: "Tunisia",
    zh_cn: "突尼斯",
    sign: "TN",
    c_code: "+216"
  },
  {
    country: "Turkey",
    zh_cn: "土耳其",
    sign: "TR",
    c_code: "+90"
  },
  {
    country: "Turkmenistan",
    zh_cn: "土库曼斯坦",
    sign: "TM",
    c_code: "+993"
  },
  {
    country: "Turks and Caicos Islands",
    zh_cn: "特克斯和凯科斯群岛",
    sign: "TC",
    c_code: "+1649"
  },
  {
    country: "Uganda",
    zh_cn: "乌干达",
    sign: "UG",
    c_code: "+256"
  },
  {
    country: "Ukraine",
    zh_cn: "乌克兰",
    sign: "UA",
    c_code: "+380"
  },
  {
    country: "United Arab Emirates",
    zh_cn: "阿拉伯联合酋长国",
    sign: "UAE",
    c_code: "+971"
  },
  {
    country: "United Kingdom",
    zh_cn: "英国",
    sign: "GB",
    c_code: "+44"
  },
  {
    country: "United States",
    zh_cn: "美国",
    sign: "US",
    c_code: "+1"
  },
  {
    country: "Uruguay",
    zh_cn: "乌拉圭",
    sign: "UY",
    c_code: "+598"
  },
  {
    country: "Uzbekistan",
    zh_cn: "乌兹别克斯坦",
    sign: "UZ",
    c_code: "+998"
  },
  {
    country: "Vanuatu",
    zh_cn: "瓦努阿图",
    sign: "VU",
    c_code: "+678"
  },
  {
    country: "Venezuela",
    zh_cn: "委内瑞拉",
    sign: "VE",
    c_code: "+58"
  },
  {
    country: "Vietnam",
    zh_cn: "越南",
    sign: "VN",
    c_code: "+84"
  },
  {
    country: "Virgin Islands, British",
    zh_cn: "英属处女群岛",
    sign: "VG",
    c_code: "+1340"
  },
  {
    country: "Virgin Islands, US",
    zh_cn: "美属维尔京群岛",
    sign: "VI",
    c_code: "+1284"
  },
  {
    country: "Yemen",
    zh_cn: "也门",
    sign: "YE",
    c_code: "+967"
  },
  {
    country: "Zambia",
    zh_cn: "赞比亚",
    sign: "ZM",
    c_code: "+260"
  },
  {
    country: "Zimbabwe",
    zh_cn: "津巴布韦",
    sign: "ZW",
    c_code: "+263"
  },
  {
    country: "China",
    zh_cn: "中国大陆",
    sign: "ZH_CN",
    c_code: "+86"
  }
]

export default w_area